import type { Template } from "@/types";

export const PO_03_H1_V2: Template[] = [
{
    id: "po-03-h1v2-01",
    name: "PO 01 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 54, y: 225, width: 551, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 613, y: 225, width: 271, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 892, y: 225, width: 271, height: 402, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h1v2-02",
    name: "PO 02 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 65, y: 229, width: 266, height: 393, rotation: 0, imageRotation: 0 },
        { id: "2", x: 339, y: 229, width: 539, height: 393, rotation: 0, imageRotation: 0 },
        { id: "3", x: 886, y: 229, width: 266, height: 393, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-03",
    name: "PO 03 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_03.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 72, y: 257, width: 228, height: 336, rotation: 0, imageRotation: 0 },
        { id: "2", x: 308, y: 257, width: 228, height: 336, rotation: 0, imageRotation: 0 },
        { id: "3", x: 674, y: 257, width: 478, height: 336, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-04",
    name: "PO 04 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_04.png",
    size: [1217, 851],
    style: {},
    slots: [    
        { id: "1", x: 68, y: 77, width: 210, height: 345, rotation: 0, imageRotation: 0 },
        { id: "2", x: 68, y: 430, width: 210, height: 345, rotation: 0, imageRotation: 0 },
        { id: "3", x: 286, y: 77, width: 863, height: 698, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-05",
    name: "PO 05 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_05.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 122, y: 146, width: 189, height: 276, rotation: 0, imageRotation: 0 },
        { id: "2", x: 122, y: 430, width: 189, height: 275, rotation: 0, imageRotation: 0 },
        { id: "3", x: 319, y: 146, width: 776, height: 559, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-06",
    name: "PO 06 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_06.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 199, y: 77, width: 210, height: 345, rotation: 0, imageRotation: 0 },
        { id: "2", x: 199, y: 430, width: 210, height: 344, rotation: 0, imageRotation: 0 },
        { id: "3", x: 646, y: 240, width: 533, height: 371, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-07",
    name: "PO 07 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 69, y: 77, width: 862, height: 697, rotation: 0, imageRotation: 0 },
        { id: "2", x: 939, y: 77, width: 210, height: 345, rotation: 0, imageRotation: 0 },
        { id: "3", x: 939, y: 430, width: 210, height: 344, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-08",
    name: "PO 08 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 123, y: 146, width: 775, height: 560, rotation: 0, imageRotation: 0 },
        { id: "2", x: 906, y: 146, width: 189, height: 276, rotation: 0, imageRotation: 0 },
        { id: "3", x: 906, y: 430, width: 189, height: 275, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-09",
    name: "PO 09 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 65, y: 257, width: 478, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 257, width: 229, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 917, y: 257, width: 228, height: 336, rotation: 0, imageRotation: 0 }
    ],
}
];